import { useQuery } from "@tanstack/react-query";
import getGeneratedBlogByBlueprint from "../api/get-generated-blog-by-blueprint";

/**
 * Fetches a generated blog post by its parent blueprint ID.
 * The query is only enabled when a non-empty `blueprintId` is supplied.
 *
 * @param blueprintId - The blueprint ID to fetch the generated post for, or `null` to disable.
 */
function useGetGeneratedBlogByBlueprint(blueprintId: string | null) {
  return useQuery({
    ...getGeneratedBlogByBlueprint(blueprintId ?? ""),
    enabled: !!blueprintId,
  });
}

export default useGetGeneratedBlogByBlueprint;
